import classNames from 'classnames';

import { MainHeroFragmentFragment } from '../../__generated__/graphql';
import AppImage from '../../components/AppImage';
import ButtonLink from '../../components/Button/ButtonLink';
import { Heading1, Paragraph } from '../../components/Text';
import { ContentBlock } from '../types';

import textStyle from '../../components/Text/text-base.module.css';
import style from './main-hero-banner.module.css';

const MainHero: ContentBlock<MainHeroFragmentFragment> = ({ fragment }) => {
  const contentBlockProps = fragment.mainHero;

  if (!contentBlockProps) {
    return null;
  }

  return (
    <section
      className={style.heroSection}
      id={contentBlockProps.sectionId ?? undefined}
    >
      <div className={style.heroBanner}>
        <div className={style.textContainer}>
          <Heading1
            className={style.title}
            fontColor="turquoise"
            fontWeight={300}
            uppercase
          >
            {contentBlockProps.title}
            <span
              className={classNames(
                textStyle.fontWeight700,
                textStyle.fontColorWhite,
              )}
            >
              {' '}
              {contentBlockProps.subtitle}
            </span>
          </Heading1>

          <Paragraph
            className={style.paragraph}
            fontColor="white"
            fontSize={22}
          >
            {contentBlockProps.description}
          </Paragraph>

          <ButtonLink
            buttonColor="orange"
            id={contentBlockProps.buttonId ?? undefined}
            linkFragment={contentBlockProps.button}
          />
        </div>

        {contentBlockProps.image && (
          <AppImage
            className={style.image}
            fallbackHeight={615}
            fallbackWidth={630}
            fetchPriority="high"
            image={contentBlockProps.image}
            priority
          />
        )}
      </div>
    </section>
  );
};

export default MainHero;
